import { uniqueId } from "lodash";
import React, { InputHTMLAttributes, useCallback, useMemo, useState } from "react";



export const CheckItem = React.forwardRef<HTMLInputElement, Props>(({ type, block, emphasis, countFuction, label, ...props }, ref) => {

    const renderId = uniqueId();

    const [isCheck, setIsCheck] = useState<boolean>(false)

    const checked = useMemo((): boolean => {
        if (props.defaultChecked)
            return true
        return false
    }, [props])

    const setSelect = useCallback((opt: boolean) => {

        if (!block && opt) {
            if (countFuction)
                countFuction(true)
            return setIsCheck(true)
        }
        if (countFuction)
        countFuction(false)
        return setIsCheck(false)
               
            
    }, [countFuction, block])

    const checkboxCheck = useMemo(() => { return isCheck }, [isCheck])

    return (
        <div className='mr-2 cursor-pointer'>
            <label htmlFor={renderId} className=" flex items-center  rounded">
                <div className="border w-4 h-4 border-gray-600  rounded mr-2 flex items-center justify-center">
                    {checked && <div className="bg-primary w-full h-full "></div>}
                    {type === 'checkbox' && isCheck && <div className="bg-primary w-full h-full "></div>}
                </div> {label} {emphasis && <span className="text-primary-dark ml-1"> {emphasis} </span>}
            </label>
            {type === 'checkbox' ?
                <input disabled={isCheck ? false : block}  {...props} className={props.name} defaultChecked={checkboxCheck} id={renderId} hidden type={type}
                    onClick={()=>setSelect(isCheck ? false : true)}
                /> :
                <input {...props} className={props.name} id={renderId} hidden defaultChecked={checked} defaultValue={1} type={type} />
            }
        </div>
    )
})

interface Props extends InputHTMLAttributes<HTMLInputElement> {
    label?: string,
    type: 'checkbox' | 'radio';
    emphasis?: string,
    block?: boolean
    countFuction?: (opt: boolean) => void
}
